<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01"><i>Barbara Cohen first put the idea of a book about King David and his wives into my mind and generously suggested that I try it, and I thank her</i>.</p>
<p class="fm-02"><i>What happened when I started to write was, of course, very different from the original idea. The story in somewhat its present form began on a fifty-foot boat called the</i> P.S., <i>which is the model for the</i> Portia, <i>and my thanks go to Phil and Sylvia Duryee; their daughter, Cornelia; and her husband, Terry Moore, with whom I have spent happy times on the</i> P.S.</p>
<p class="fm-03"><span class="smallcaps">M</span>. <span class="smallcaps">L</span>’<span class="smallcaps">E</span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?6951e30f